export default "__VITE_ASSET__f3e92b9b__"